import MojitoCore from 'mojito/core';
const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;

export default class PasswordChangeView extends UIViewImplementation {
    render() {
        return <div className="PasswordChangeView">{'To be implemented!'}</div>;
    }
}

PasswordChangeView.getStyle = function (/* Config, applicationMode, merge*/) {
    return {};
};
